import { AutoStaffButton, StyledTypography } from './AutoStaff.styles';
import { AutoStaffIcon } from '../../assets/svg';
import { showErrorToast, showSuccessToast } from '../../utils/toastUtils';
import { useDispatch, useSelector } from 'react-redux';
import { autoStaffShifts } from '../../redux/shifts/shiftsThunks';
import { selectCurrentVenue } from '../../redux/slices/currentUserSlice';
import { selectAutoStaffingStatus } from '../../redux/shifts/shiftsSlice';
import dayjs from 'dayjs';

const AutoStaff = ({
  variant = 'dark',
  fullWidth = false,
  selectedDay = null,
  periodHasShifts = false,
  component = null,
  noIcon = false,
  rightIcon = false,
  iconSize = 32,
}) => {
  const dispatch = useDispatch();

  //SELECTORS
  const { id: venueId } = useSelector(selectCurrentVenue);
  const isLoading = useSelector(selectAutoStaffingStatus) === 'loading';
  const period = useSelector((state) => state.newShifts.period);

  // Custom component
  const Component = component || AutoStaffButton;

  // Dispatch the autoStaffShifts thunk to copy the shifts from the last week to the new week
  const handleAutoStaffClick = async () => {
    try {
      let days;

      if (selectedDay) {
        // If selectedDay is provided (from day drilldown), use only that day
        days = [dayjs(selectedDay).format('YYYY-MM-DD')];
      } else {
        // If no selectedDay (from shifts page), use the entire period
        const start = dayjs(period.start);
        const end = dayjs(period.end);
        days = [];

        for (let d = start; d.isSameOrBefore(end, 'day'); d = d.add(1, 'day')) {
          days.push(d.format('YYYY-MM-DD'));
        }
      }

      const result = await dispatch(autoStaffShifts({ venueId, days })).unwrap();
      const count = result?.meta?.addedCount ?? 0;

      showSuccessToast(`Auto-staffed ${count} new shift${count !== 1 ? 's' : ''}`);
    } catch (error) {
      showErrorToast(`Failed to auto-staff shifts (${error.message})`);
    }
  };

  return (
    <Component
      onClick={handleAutoStaffClick}
      disabled={isLoading || periodHasShifts}
      variant={variant}
      fullWidth={fullWidth}
    >
      {!noIcon && !rightIcon && <AutoStaffIcon size={iconSize} />}
      <StyledTypography variant="bodyRegular">
        {isLoading ? 'Auto-staffing shifts...' : 'Auto-staff with Tempo'}
      </StyledTypography>
      {!noIcon && rightIcon && <AutoStaffIcon size={iconSize} />}
    </Component>
  );
};

export default AutoStaff;
